import { useMemo } from 'react';

import { useCurrentUser } from './useApiKey';

export function useHasTeam() {
    const [currentUser] = useCurrentUser();
    const hasTeam = useMemo(() => {
        return currentUser ? !!currentUser.teamId : false;
    }, [currentUser]);

    return hasTeam;
}
